var differentDeliveryOptions = {
    isSelectedDifferentAddress: false
}
var differentDeliveryMethod;
var CheckoutDifferentAddressJs = (function ($) {
    var $radioButtons;
    var $clickElem;
    var showHideDifferentDeliveryAddress = function (target, elemSel) {
        if (target.attr("value") === differentDeliveryMethod) {
            $(".j-checkout-address-other").show();

            const flagContainers = document.querySelectorAll('.iti__flag-container');
            const mobileQuery = window.matchMedia('(max-width: 767px)');

            if (flagContainers.length > 1 && mobileQuery.matches && navigator.userAgent.includes('Firefox')) {
                flagContainers[1].removeAttribute("style");

                setTimeout(function () {
                    flagContainers[1].style.left = 'auto';
                    flagContainers[1].style.top = '34px';
                }, 10);

            }
        } else {
            $(".j-checkout-address-other").hide();
        }
    };

    var initShowHideDifferentDel = function (radioButtonsSel, elemSel) {
        var radioBSel = radioButtonsSel + " input[type='radio']";
        showHideDifferentDeliveryAddress($(radioBSel + '[name=deliveryMethod]:checked'), ".j-checkout-address-other");
        $(radioBSel).on("click", function () {
            showHideDifferentDeliveryAddress($(this), elemSel);
        });
    };

    return {
        initShowHideDifferentDel: initShowHideDifferentDel,
        showHideDifferentDeliveryAddress: showHideDifferentDeliveryAddress
    }
})(jQuery);

$(document).ready(function () {
    if (typeof $("#differentRadioButton") !== 'undefined' && typeof $("#differentRadioButton").val() !== 'undefined') {
        differentDeliveryMethod = $("#differentRadioButton").val();
        CheckoutDifferentAddressJs.initShowHideDifferentDel(".j-delivery-method-radio-buttons", ".j-checkout-address-other");
    }
});